import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-datepicker',
  template: `
    <div class="">
      <p-datepicker
        [formControl]="dateControl"
        styleClass="w-full"
        showIcon="true"
        [dateFormat]="props['dateFormat'] || 'dd M yy'"
        [placeholder]="props['placeholder'] || undefined"
        appendTo="body"
        [maxDate]="props['maxDate'] || null"
      />
    </div>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDatePickerComponent extends FieldType implements OnInit {
  // The picker works in local Date objects; the form model holds a
  // timezone-safe "YYYY-MM-DD" string so it round-trips without day shifts.
  dateControl = new FormControl<Date | null>(null);

  ngOnInit(): void {
    this.dateControl.setValue(this._toDate(this.formControl.value), {
      emitEvent: false,
    });

    // Picker (Date) -> model ("YYYY-MM-DD")
    this.dateControl.valueChanges.subscribe((d) => {
      this.formControl.setValue(this._toDateOnly(d));
    });

    // External/programmatic model change -> picker
    this.formControl.valueChanges.subscribe((value) => {
      if ((value ?? null) !== (this._toDateOnly(this.dateControl.value) ?? null)) {
        this.dateControl.setValue(this._toDate(value), { emitEvent: false });
      }
    });
  }

  // Parse a model value into a local Date. A "YYYY-MM-DD" (or leading date of an
  // ISO datetime) is built in local time so it isn't shifted by the timezone.
  private _toDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  private _toDateOnly(value: Date | null): string | null {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  constructor() {
    super();
  }
}
